var _ref2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgShower = function SvgShower(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 10.649,
    height: 12.101,
    viewBox: "0 0 10.649 12.101",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2 || (_ref2 = React.createElement("g", {
    id: "Group_8637",
    "data-name": "Group 8637",
    transform: "translate(0.749 0.75)"
  }, React.createElement("path", {
    id: "Path_7086",
    "data-name": "Path 7086",
    d: "M-19555.467,10707.6a1.793,1.793,0,0,0-1.977-1.909h-2.6a1.308,1.308,0,0,0-1.428,1.382v9.219",
    transform: "translate(19561.467 -10705.694)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), React.createElement("path", {
    id: "Path_7087",
    "data-name": "Path 7087",
    d: "M-19561.469,10717.225v.566",
    transform: "translate(19565.367 -10710.712)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), React.createElement("path", {
    id: "Path_7091",
    "data-name": "Path 7091",
    d: "M-19561.469,10717.225v.566",
    transform: "translate(19565.367 -10708.454)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), React.createElement("path", {
    id: "Path_7090",
    "data-name": "Path 7090",
    d: "M-19561.469,10717.225v2.26",
    transform: "translate(19567.469 -10710.712)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), React.createElement("path", {
    id: "Path_7089",
    "data-name": "Path 7089",
    d: "M-19561.469,10717.225v.566",
    transform: "translate(19569.57 -10710.712)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), React.createElement("path", {
    id: "Path_7092",
    "data-name": "Path 7092",
    d: "M-19561.469,10717.225v.566",
    transform: "translate(19569.57 -10708.454)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), React.createElement("g", {
    id: "Path_7085",
    "data-name": "Path 7085",
    transform: "translate(3 1.694)",
    fill: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, React.createElement("path", {
    d: "M 5.441723346710205 2.323524713516235 L 0.5582771301269531 2.323524713516235 C 0.8049914240837097 1.281784296035767 1.806096792221069 0.5000046491622925 3.000000238418579 0.5000046491622925 C 4.193903923034668 0.5000046491622925 5.195009231567383 1.281784296035767 5.441723346710205 2.323524713516235 Z",
    stroke: "none"
  }), React.createElement("path", {
    d: "M 3.000000238418579 1.000004649162292 C 2.301865339279175 1.000004649162292 1.686130523681641 1.327834367752075 1.328250408172607 1.823524594306946 L 4.671750068664551 1.823524594306946 C 4.313869476318359 1.327834367752075 3.698135137557983 1.000004649162292 3.000000238418579 1.000004649162292 M 3.000000238418579 4.529953002929688e-06 C 4.656850337982178 4.529953002929688e-06 6 1.264134645462036 6 2.823524713516235 L 4.76837158203125e-07 2.823524713516235 C 4.76837158203125e-07 1.264134645462036 1.34315013885498 4.529953002929688e-06 3.000000238418579 4.529953002929688e-06 Z",
    stroke: "none",
    fill: "#fff"
  })), React.createElement("g", {
    id: "Rectangle_2632",
    "data-name": "Rectangle 2632",
    transform: "translate(2.1 4.518)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }, React.createElement("rect", {
    width: 7.8,
    height: 1.129,
    rx: 0.565,
    stroke: "none"
  }), React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 6.8,
    height: 0.129,
    rx: 0.065,
    fill: "none"
  })))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgShower, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shower.7498aead.svg";
export { ForwardRef as ReactComponent };